import { render, staticRenderFns } from "./FSGPromoArea.vue?vue&type=template&id=5fccb602&scoped=true&"
import script from "./FSGPromoArea.vue?vue&type=script&lang=js&"
export * from "./FSGPromoArea.vue?vue&type=script&lang=js&"
import style0 from "./FSGPromoArea.vue?vue&type=style&index=0&id=5fccb602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fccb602",
  null
  
)

export default component.exports